// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
    min-height: calc(100vh - 68px);
    height: calc(100vh - 68px - 2rem);
    padding: 2rem;
    padding-bottom: 2rem;
    max-width: 100vw;
    overflow-x: hidden;
    overflow-y: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.home-container {
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

/* Стили для авторизованного состояния */
.panels {
    display: grid;
    grid-template-columns: 320px 1fr;
    gap: 1.5rem;
    margin-bottom: 2rem;
    align-items: start;
    flex: 1 1;
    min-height: 0;
    height: 100%;
}

.panels-right {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    min-width: 0;
    height: 100%;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 0.5rem;
    scrollbar-width: thin !important;
    scrollbar-color: #3f3f46 #18181b !important;
}

.panels-right::-webkit-scrollbar {
    width: 8px !important;
}

.panels-right::-webkit-scrollbar-track {
    background: #18181b !important;
    border-radius: 4px;
    margin: 4px 0;
}

.panels-right::-webkit-scrollbar-thumb {
    background: #3f3f46 !important;
    border-radius: 4px;
    -webkit-transition: background 0.2s, box-shadow 0.2s;
    transition: background 0.2s, box-shadow 0.2s;
}

.panels-right::-webkit-scrollbar-thumb:hover {
    background: #3b82f6 !important;
    box-shadow: 0 0 4px rgba(59, 130, 246, 0.25);
}

.panel-info {
    position: sticky;
    top: 1.5rem;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    align-self: start;
    padding-right: 0.5rem;
}

.panel-info::-webkit-scrollbar {
    width: 8px !important;
}

.panel-info::-webkit-scrollbar-track {
    background: #18181b !important;
    border-radius: 4px;
}

.panel-info::-webkit-scrollbar-thumb {
    background: #3f3f46 !important;
    border-radius: 4px;
    -webkit-transition: background 0.2s;
    transition: background 0.2s;
}

.panel-info::-webkit-scrollbar-thumb:hover {
    background: #3b82f6 !important;
}

.panel-tariff {
    flex-shrink: 0;
    padding: 1rem 1.25rem;
    border-left: 3px solid var(--accent);
    background: linear-gradient(135deg, var(--bg-card) 0%, rgba(59, 130, 246, 0.05) 100%);
}

.panel-tariff h2 {
    font-size: 1.1rem;
    margin-bottom: 0.75rem;
    color: var(--accent);
}

.tariff-text {
    margin: 0;
    color: var(--text-primary);
    line-height: 1.6;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.panel-tariff:hover {
    border-left-color: var(--accent-light);
    box-shadow: 0 4px 16px var(--accent-glow);
}

.panel-notifications {
    flex: 1 1 auto;
    min-height: auto;
    display: flex;
    flex-direction: column;
    overflow: visible;
}

.panel-notifications .panel-content.notification-container {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid var(--border-color);
    overflow: visible;
}

.panel {
    background: var(--bg-card);
    border-radius: var(--radius);
    padding: 1.5rem;
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-color);
    border-top: 2px solid var(--border-subtle);
    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.2s, background 0.2s;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.panel:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-accent);
    border-top-color: rgba(59, 130, 246, 0.4);
    background: var(--bg-card-hover);
}

.panel h2 {
    color: var(--accent);
    margin-bottom: 1rem;
    font-size: 1.5rem;
    font-weight: 600;
    letter-spacing: -0.02em;
}

.panel p {
    color: var(--text-secondary);
    line-height: 1.6;
}

.panel-content {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid var(--border-color);
}

.panel-notifications .panel-content {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid var(--border-color);
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
}

.panel:hover .panel-content {
    border-top-color: var(--border-color);
}

.account-info-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.account-info-list li {
    margin-bottom: 0.5rem;
    color: var(--text-secondary);
    line-height: 1.5;
}

.account-info-list li strong {
    color: var(--text-primary);
    margin-right: 0.35rem;
}

.account-delete-button {
    margin-top: 1.25rem;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    font-weight: 500;
    font-family: var(--font);
    color: #b91c1c;
    background: transparent;
    border: 1px solid #b91c1c;
    border-radius: var(--radius-sm);
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, transform 0.2s;
}

.account-delete-button:hover:not(:disabled) {
    background: #b91c1c;
    color: #fef2f2;
    border-color: #b91c1c;
    transform: translateY(-1px);
}

.account-delete-button:active:not(:disabled) {
    transform: translateY(0);
}

.account-delete-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.delete-account-modal-body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.delete-account-modal-warning {
    margin: 0;
    color: var(--text-secondary);
    font-size: 0.95rem;
    line-height: 1.6;
}

.delete-account-modal-error {
    color: var(--error);
    font-size: 0.9rem;
}

.delete-account-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 0.25rem;
}

.account-delete-confirm-btn {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    font-weight: 500;
    font-family: var(--font);
    color: #b91c1c;
    background: transparent;
    border: 1px solid #b91c1c;
    border-radius: var(--radius-sm);
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, transform 0.2s;
}

.account-delete-confirm-btn:hover:not(:disabled) {
    background: #b91c1c;
    color: #fef2f2;
    border-color: #b91c1c;
    transform: translateY(-1px);
}

.account-delete-confirm-btn:active:not(:disabled) {
    transform: translateY(0);
}

.account-delete-confirm-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.account-delete-cancel-btn {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    font-weight: 500;
    font-family: var(--font);
    color: var(--text-secondary);
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-sm);
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, color 0.2s;
}

.account-delete-cancel-btn:hover:not(:disabled) {
    background: var(--input-bg);
    border-color: var(--accent);
    color: var(--text-primary);
}

/* Стили для неавторизованного состояния */
.welcome-section {
    text-align: center;
    padding: 3rem 2rem;
    background: var(--bg-card);
    border-radius: var(--radius);
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-color);
    border-top: 2px solid var(--border-subtle);
    position: relative;
    overflow: hidden;
}

.welcome-section::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--accent), transparent);
    opacity: 0.4;
}

.welcome-section h1 {
    color: var(--accent);
    font-size: 2.5rem;
    font-weight: 700;
    letter-spacing: -0.03em;
    margin-bottom: 1rem;
}

.welcome-text {
    font-size: 1.1rem;
    color: var(--text-secondary);
    max-width: 600px;
    margin: 0 auto 2rem;
    line-height: 1.6;
}

.auth-buttons {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin: 2rem 0;
}

.auth-btn {
    padding: 0.75rem 2rem;
    border-radius: var(--radius-sm);
    text-decoration: none;
    font-weight: 600;
    font-family: var(--font);
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s;
    display: inline-block;
}

.login-btn {
    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
    color: white;
    box-shadow: 0 4px 14px var(--accent-glow);
}

.login-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px var(--accent-glow);
}

.register-btn {
    background: var(--bg-card);
    color: var(--accent);
    border: 2px solid var(--border-subtle);
}

.register-btn:hover {
    background: var(--bg-card-hover);
    border-color: var(--accent);
    transform: translateY(-2px);
    box-shadow: 0 4px 14px var(--accent-glow);
}

/* Демо-переключатель (удалить в продакшене) */
.demo-switcher {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    color: var(--text-primary);
    padding: 1rem;
    border-radius: 8px;
    font-size: 0.9rem;
    z-index: 1000;
}

.demo-btn {
    background-color: var(--accent);
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    margin-top: 0.5rem;
    cursor: pointer;
    width: 100%;
}

.demo-btn:hover {
    background-color: var(--accent-hover);
}

/* Планшет */
@media (max-width: 768px) {
    .home {
        padding: 1rem;
        min-height: calc(100vh - 52px);
        overflow-y: auto;
        overflow-x: hidden;
    }

    .panels {
        grid-template-columns: 1fr;
        gap: 1.25rem;
        margin-bottom: 1.5rem;
    }

    .panel-info {
        position: static;
        max-height: none;
        overflow-y: visible;
    }

    .panels-right {
        gap: 1.25rem;
        overflow-y: visible;
        height: auto;
    }

    .panel-notifications {
        min-height: auto;
        max-height: none;
    }

    .panel {
        padding: 1.25rem;
    }

    .panel h2 {
        font-size: 1.25rem;
    }

    .auth-buttons {
        flex-direction: column;
        align-items: center;
        gap: 0.75rem;
        margin: 1.5rem 0;
    }

    .auth-btn {
        width: 100%;
        max-width: 300px;
        text-align: center;
        padding: 0.85rem 1.5rem;
        min-height: 48px;
    }

    .welcome-section {
        padding: 2rem 1rem;
    }

    .welcome-section h1 {
        font-size: 2rem;
    }

    .welcome-text {
        font-size: 1rem;
    }
}

/* Телефон */
@media (max-width: 480px) {
    .home {
        padding: 0.75rem;
        min-height: calc(100vh - 48px);
        overflow-y: auto;
        overflow-x: hidden;
    }

    .panels {
        gap: 1rem;
        margin-bottom: 1rem;
    }

    .panel-info {
        overflow-y: visible;
    }

    .panels-right {
        overflow-y: visible;
        height: auto;
    }

    .panel-tariff {
        padding: 0.85rem 1rem;
    }

    .panel-tariff h2 {
        font-size: 1rem;
    }

    .panel-notifications {
        min-height: auto;
        max-height: none;
    }

    .panel {
        padding: 1rem;
        border-radius: 10px;
    }

    .panel h2 {
        font-size: 1.1rem;
        margin-bottom: 0.75rem;
    }

    .panel p,
    .account-info-list li {
        font-size: 0.9rem;
    }

    .auth-buttons {
        margin: 1rem 0;
        gap: 0.5rem;
    }

    .auth-btn {
        max-width: 100%;
        padding: 0.75rem 1.25rem;
        min-height: 44px;
        font-size: 0.95rem;
    }

    .welcome-section {
        padding: 1.5rem 0.75rem;
        border-radius: 10px;
    }

    .welcome-section h1 {
        font-size: 1.5rem;
        margin-bottom: 1rem;
    }

    .welcome-text {
        font-size: 0.95rem;
        margin-bottom: 1.5rem;
    }
}

.notification-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    overflow: visible;
}

.panel-info {
    scrollbar-width: thin;
    scrollbar-color: #3f3f46 #18181b;
}


.no-notifications {
    text-align: center;
    color: var(--text-muted);
    padding: 2rem 1rem;
    font-style: italic;
}

.notification-item {
    position: relative;
    border-radius: var(--radius-sm);
    padding: 1rem 1.25rem;
    margin-bottom: 0;
    background: var(--bg-card);
    border: 2px solid;
    color: var(--text-primary);
    transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s, border-color 0.2s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    overflow: visible;
    max-width: 100%;
    box-sizing: border-box;
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
}

.notification-item::-webkit-scrollbar {
    display: none !important;
}

.notification-item:hover {
    transform: translateX(4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.notification-content {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    overflow: visible;
    max-width: 100%;
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
}

.notification-content::-webkit-scrollbar {
    display: none !important;
}

.notification-text {
    margin: 0;
    color: var(--text-primary);
    line-height: 1.5;
    word-wrap: break-word;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    word-break: break-word;
    overflow: visible;
    max-width: 100%;
}

.notification-text::-webkit-scrollbar {
    display: none !important;
}

.notification-link-btn {
    align-self: flex-start;
    background: var(--accent);
    border: 1px solid var(--accent);
    color: white;
    padding: 0.5rem 1rem;
    border-radius: var(--radius-sm);
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    font-family: var(--font);
    transition: background 0.2s, border-color 0.2s, transform 0.2s;
    margin-top: 0.25rem;
}

.notification-link-btn:hover {
    background: var(--accent-hover);
    border-color: var(--accent-hover);
    transform: translateY(-1px);
}

.notification-link-btn:active {
    transform: translateY(0);
}

.notification-download-btn {
    align-self: flex-start;
    background: transparent;
    border: 1px solid var(--accent);
    color: var(--accent-light);
    padding: 0.5rem 1rem;
    border-radius: var(--radius-sm);
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    font-family: var(--font);
    transition: background 0.2s, border-color 0.2s, transform 0.2s;
    margin-top: 0.25rem;
}

.notification-download-btn:hover {
    background: var(--accent-glow);
    border-color: var(--accent);
    color: var(--text-primary);
    transform: translateY(-1px);
}

.notification-download-btn:active {
    transform: translateY(0);
}

.call-request-form {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 0.75rem;
    width: 100%;
}

.call-request-label {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    font-size: 0.9rem;
    color: var(--text-secondary);
}

.call-request-input,
.call-request-textarea {
    width: 100%;
    padding: 0.6rem 0.75rem;
    border-radius: var(--radius-sm);
    border: 1px solid var(--input-border);
    background: var(--input-bg);
    color: var(--text-primary);
    font-family: var(--font);
    font-size: 0.95rem;
    box-sizing: border-box;
}

.call-request-textarea {
    resize: vertical;
    min-height: 4rem;
}

.call-request-input:focus,
.call-request-textarea:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 2px var(--accent-glow);
}

.call-request-error {
    color: var(--error);
    font-size: 0.85rem;
}

.notification-actions {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.5rem;
    flex-wrap: wrap;
}

.notification-confirm-btn,
.notification-decline-btn {
    min-width: 120px;
    padding: 0.45rem 0.9rem;
    border-radius: var(--radius-sm);
    font-size: 0.9rem;
    font-weight: 500;
    font-family: var(--font);
    cursor: pointer;
    border-width: 1px;
    border-style: solid;
    transition: background 0.2s, border-color 0.2s, color 0.2s, transform 0.2s;
}

.notification-confirm-btn {
    background: #16a34a;
    border-color: #16a34a;
    color: #f9fafb;
}

.notification-confirm-btn:hover {
    background: #22c55e;
    border-color: #22c55e;
    transform: translateY(-1px);
}

.notification-confirm-btn:active {
    transform: translateY(0);
}

.notification-decline-btn {
    background: transparent;
    border-color: #b96f80;
    color: #fce7f3;
}

.notification-decline-btn:hover {
    background: rgba(185, 111, 128, 0.15);
    border-color: #b96f80;
    color: #fdf2f8;
    transform: translateY(-1px);
}

.notification-decline-btn:active {
    transform: translateY(0);
}

.notification-decline-btn.secondary {
    background: var(--bg-secondary);
    border-color: var(--border-color);
    color: var(--text-secondary);
}

.notification-decline-btn.secondary:hover {
    background: var(--input-bg);
    border-color: var(--accent);
    color: var(--text-primary);
}

.decline-modal-body {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.decline-modal-text {
    margin: 0;
    color: var(--text-secondary);
    font-size: 0.9rem;
}

.decline-modal-textarea {
    width: 100%;
    min-height: 100px;
    resize: vertical;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border-color);
    padding: 0.5rem 0.75rem;
    background: var(--input-bg);
    color: var(--text-primary);
    font-family: var(--font);
    font-size: 0.9rem;
}

.decline-modal-textarea:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.4);
}

.decline-modal-error {
    color: var(--error);
    font-size: 0.85rem;
}

.decline-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.notification-close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    color: var(--text-primary);
    width: 24px;
    height: 24px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 1.2rem;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s, transform 0.2s, border-color 0.2s;
    padding: 0;
    flex-shrink: 0;
}

.notification-close:hover {
    background: var(--input-bg);
    border-color: var(--accent);
    transform: scale(1.1);
}

.notification-close:active {
    transform: scale(0.95);
}

/* Старые классы для обратной совместимости (если используются где-то еще) */
.notification {
    background-color: black;
    border-radius: 12px;
    padding: 4px 12px 4px 12px;
    margin-bottom: 12px;
    color: white;
}

.notification p {
    color: white;
}

.error {
    background-color: #bc4747;
}

.warning {
    background-color: #cfa332;
}

.success {
    background-color: #47bc70;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Home.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,iCAAiC;IACjC,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,gCAAgC;IAChC,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,SAAO;IACP,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;IAChC,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,oDAA4C;IAA5C,4CAA4C;AAChD;;AAEA;IACI,8BAA8B;IAC9B,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mCAA2B;IAA3B,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,oCAAoC;IACpC,qFAAqF;AACzF;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,eAAe;IACf,8BAA8B;IAC9B,qCAAqC;IACrC,0CAA0C;IAC1C,2FAA2F;IAC3F,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;IAChC,yCAAyC;IACzC,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;IACzC,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;IACf,8DAA8D;AAClE;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;IACf,8DAA8D;AAClE;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,4BAA4B;IAC5B,+BAA+B;IAC/B,qCAAqC;IACrC,+BAA+B;IAC/B,eAAe;IACf,0DAA0D;AAC9D;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA,0CAA0C;AAC1C;IACI,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,2EAA2E;IAC3E,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,sEAAsE;IACtE,qBAAqB;AACzB;;AAEA;IACI,+EAA+E;IAC/E,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA,8CAA8C;AAC9C;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,qCAAqC;IACrC,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA,YAAY;AACZ;IACI;QACI,aAAa;QACb,8BAA8B;QAC9B,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,YAAY;AACZ;IACI;QACI,gBAAgB;QAChB,8BAA8B;QAC9B,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,eAAe;QACf,wBAAwB;QACxB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;;AAGA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,0BAA0B;IAC1B,sFAAsF;IACtF,wCAAwC;IACxC,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,YAAY;IACZ,oBAAoB;IACpB,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,8DAA8D;IAC9D,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,+BAA+B;IAC/B,0BAA0B;IAC1B,oBAAoB;IACpB,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,8DAA8D;IAC9D,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;;IAEI,WAAW;IACX,uBAAuB;IACvB,+BAA+B;IAC/B,qCAAqC;IACrC,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,uBAAuB;IACvB,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,0EAA0E;AAC9E;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;IAC/B,qCAAqC;IACrC,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,+BAA+B;IAC/B,qCAAqC;IACrC,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8DAA8D;IAC9D,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,4EAA4E;AAC5E;IACI,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".home {\n    min-height: calc(100vh - 68px);\n    height: calc(100vh - 68px - 2rem);\n    padding: 2rem;\n    padding-bottom: 2rem;\n    max-width: 100vw;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n}\n\n.home-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    width: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n/* Стили для авторизованного состояния */\n.panels {\n    display: grid;\n    grid-template-columns: 320px 1fr;\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n    align-items: start;\n    flex: 1;\n    min-height: 0;\n    height: 100%;\n}\n\n.panels-right {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    min-width: 0;\n    height: 100%;\n    min-height: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding-right: 0.5rem;\n    scrollbar-width: thin !important;\n    scrollbar-color: #3f3f46 #18181b !important;\n}\n\n.panels-right::-webkit-scrollbar {\n    width: 8px !important;\n}\n\n.panels-right::-webkit-scrollbar-track {\n    background: #18181b !important;\n    border-radius: 4px;\n    margin: 4px 0;\n}\n\n.panels-right::-webkit-scrollbar-thumb {\n    background: #3f3f46 !important;\n    border-radius: 4px;\n    transition: background 0.2s, box-shadow 0.2s;\n}\n\n.panels-right::-webkit-scrollbar-thumb:hover {\n    background: #3b82f6 !important;\n    box-shadow: 0 0 4px rgba(59, 130, 246, 0.25);\n}\n\n.panel-info {\n    position: sticky;\n    top: 1.5rem;\n    max-height: calc(100vh - 100px);\n    overflow-y: auto;\n    align-self: start;\n    padding-right: 0.5rem;\n}\n\n.panel-info::-webkit-scrollbar {\n    width: 8px !important;\n}\n\n.panel-info::-webkit-scrollbar-track {\n    background: #18181b !important;\n    border-radius: 4px;\n}\n\n.panel-info::-webkit-scrollbar-thumb {\n    background: #3f3f46 !important;\n    border-radius: 4px;\n    transition: background 0.2s;\n}\n\n.panel-info::-webkit-scrollbar-thumb:hover {\n    background: #3b82f6 !important;\n}\n\n.panel-tariff {\n    flex-shrink: 0;\n    padding: 1rem 1.25rem;\n    border-left: 3px solid var(--accent);\n    background: linear-gradient(135deg, var(--bg-card) 0%, rgba(59, 130, 246, 0.05) 100%);\n}\n\n.panel-tariff h2 {\n    font-size: 1.1rem;\n    margin-bottom: 0.75rem;\n    color: var(--accent);\n}\n\n.tariff-text {\n    margin: 0;\n    color: var(--text-primary);\n    line-height: 1.6;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n}\n\n.panel-tariff:hover {\n    border-left-color: var(--accent-light);\n    box-shadow: 0 4px 16px var(--accent-glow);\n}\n\n.panel-notifications {\n    flex: 1 1 auto;\n    min-height: auto;\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n}\n\n.panel-notifications .panel-content.notification-container {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    margin-top: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid var(--border-color);\n    overflow: visible;\n}\n\n.panel {\n    background: var(--bg-card);\n    border-radius: var(--radius);\n    padding: 1.5rem;\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-color);\n    border-top: 2px solid var(--border-subtle);\n    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.2s, background 0.2s;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.panel:hover {\n    transform: translateY(-4px);\n    box-shadow: var(--shadow-accent);\n    border-top-color: rgba(59, 130, 246, 0.4);\n    background: var(--bg-card-hover);\n}\n\n.panel h2 {\n    color: var(--accent);\n    margin-bottom: 1rem;\n    font-size: 1.5rem;\n    font-weight: 600;\n    letter-spacing: -0.02em;\n}\n\n.panel p {\n    color: var(--text-secondary);\n    line-height: 1.6;\n}\n\n.panel-content {\n    margin-top: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid var(--border-color);\n}\n\n.panel-notifications .panel-content {\n    margin-top: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid var(--border-color);\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.panel:hover .panel-content {\n    border-top-color: var(--border-color);\n}\n\n.account-info-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.account-info-list li {\n    margin-bottom: 0.5rem;\n    color: var(--text-secondary);\n    line-height: 1.5;\n}\n\n.account-info-list li strong {\n    color: var(--text-primary);\n    margin-right: 0.35rem;\n}\n\n.account-delete-button {\n    margin-top: 1.25rem;\n    padding: 0.5rem 1rem;\n    font-size: 0.9rem;\n    font-weight: 500;\n    font-family: var(--font);\n    color: #b91c1c;\n    background: transparent;\n    border: 1px solid #b91c1c;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    transition: background 0.2s, border-color 0.2s, transform 0.2s;\n}\n\n.account-delete-button:hover:not(:disabled) {\n    background: #b91c1c;\n    color: #fef2f2;\n    border-color: #b91c1c;\n    transform: translateY(-1px);\n}\n\n.account-delete-button:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n.account-delete-button:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.delete-account-modal-body {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.delete-account-modal-warning {\n    margin: 0;\n    color: var(--text-secondary);\n    font-size: 0.95rem;\n    line-height: 1.6;\n}\n\n.delete-account-modal-error {\n    color: var(--error);\n    font-size: 0.9rem;\n}\n\n.delete-account-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    margin-top: 0.25rem;\n}\n\n.account-delete-confirm-btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.9rem;\n    font-weight: 500;\n    font-family: var(--font);\n    color: #b91c1c;\n    background: transparent;\n    border: 1px solid #b91c1c;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    transition: background 0.2s, border-color 0.2s, transform 0.2s;\n}\n\n.account-delete-confirm-btn:hover:not(:disabled) {\n    background: #b91c1c;\n    color: #fef2f2;\n    border-color: #b91c1c;\n    transform: translateY(-1px);\n}\n\n.account-delete-confirm-btn:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n.account-delete-confirm-btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.account-delete-cancel-btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.9rem;\n    font-weight: 500;\n    font-family: var(--font);\n    color: var(--text-secondary);\n    background: var(--bg-secondary);\n    border: 1px solid var(--border-color);\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    transition: background 0.2s, border-color 0.2s, color 0.2s;\n}\n\n.account-delete-cancel-btn:hover:not(:disabled) {\n    background: var(--input-bg);\n    border-color: var(--accent);\n    color: var(--text-primary);\n}\n\n/* Стили для неавторизованного состояния */\n.welcome-section {\n    text-align: center;\n    padding: 3rem 2rem;\n    background: var(--bg-card);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-color);\n    border-top: 2px solid var(--border-subtle);\n    position: relative;\n    overflow: hidden;\n}\n\n.welcome-section::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 60%;\n    height: 1px;\n    background: linear-gradient(90deg, transparent, var(--accent), transparent);\n    opacity: 0.4;\n}\n\n.welcome-section h1 {\n    color: var(--accent);\n    font-size: 2.5rem;\n    font-weight: 700;\n    letter-spacing: -0.03em;\n    margin-bottom: 1rem;\n}\n\n.welcome-text {\n    font-size: 1.1rem;\n    color: var(--text-secondary);\n    max-width: 600px;\n    margin: 0 auto 2rem;\n    line-height: 1.6;\n}\n\n.auth-buttons {\n    display: flex;\n    justify-content: center;\n    gap: 1rem;\n    margin: 2rem 0;\n}\n\n.auth-btn {\n    padding: 0.75rem 2rem;\n    border-radius: var(--radius-sm);\n    text-decoration: none;\n    font-weight: 600;\n    font-family: var(--font);\n    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s;\n    display: inline-block;\n}\n\n.login-btn {\n    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\n    color: white;\n    box-shadow: 0 4px 14px var(--accent-glow);\n}\n\n.login-btn:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px var(--accent-glow);\n}\n\n.register-btn {\n    background: var(--bg-card);\n    color: var(--accent);\n    border: 2px solid var(--border-subtle);\n}\n\n.register-btn:hover {\n    background: var(--bg-card-hover);\n    border-color: var(--accent);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 14px var(--accent-glow);\n}\n\n/* Демо-переключатель (удалить в продакшене) */\n.demo-switcher {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    background: var(--bg-card);\n    border: 1px solid var(--border-color);\n    color: var(--text-primary);\n    padding: 1rem;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    z-index: 1000;\n}\n\n.demo-btn {\n    background-color: var(--accent);\n    color: white;\n    border: none;\n    padding: 0.5rem 1rem;\n    border-radius: 6px;\n    margin-top: 0.5rem;\n    cursor: pointer;\n    width: 100%;\n}\n\n.demo-btn:hover {\n    background-color: var(--accent-hover);\n}\n\n/* Планшет */\n@media (max-width: 768px) {\n    .home {\n        padding: 1rem;\n        min-height: calc(100vh - 52px);\n        overflow-y: auto;\n        overflow-x: hidden;\n    }\n\n    .panels {\n        grid-template-columns: 1fr;\n        gap: 1.25rem;\n        margin-bottom: 1.5rem;\n    }\n\n    .panel-info {\n        position: static;\n        max-height: none;\n        overflow-y: visible;\n    }\n\n    .panels-right {\n        gap: 1.25rem;\n        overflow-y: visible;\n        height: auto;\n    }\n\n    .panel-notifications {\n        min-height: auto;\n        max-height: none;\n    }\n\n    .panel {\n        padding: 1.25rem;\n    }\n\n    .panel h2 {\n        font-size: 1.25rem;\n    }\n\n    .auth-buttons {\n        flex-direction: column;\n        align-items: center;\n        gap: 0.75rem;\n        margin: 1.5rem 0;\n    }\n\n    .auth-btn {\n        width: 100%;\n        max-width: 300px;\n        text-align: center;\n        padding: 0.85rem 1.5rem;\n        min-height: 48px;\n    }\n\n    .welcome-section {\n        padding: 2rem 1rem;\n    }\n\n    .welcome-section h1 {\n        font-size: 2rem;\n    }\n\n    .welcome-text {\n        font-size: 1rem;\n    }\n}\n\n/* Телефон */\n@media (max-width: 480px) {\n    .home {\n        padding: 0.75rem;\n        min-height: calc(100vh - 48px);\n        overflow-y: auto;\n        overflow-x: hidden;\n    }\n\n    .panels {\n        gap: 1rem;\n        margin-bottom: 1rem;\n    }\n\n    .panel-info {\n        overflow-y: visible;\n    }\n\n    .panels-right {\n        overflow-y: visible;\n        height: auto;\n    }\n\n    .panel-tariff {\n        padding: 0.85rem 1rem;\n    }\n\n    .panel-tariff h2 {\n        font-size: 1rem;\n    }\n\n    .panel-notifications {\n        min-height: auto;\n        max-height: none;\n    }\n\n    .panel {\n        padding: 1rem;\n        border-radius: 10px;\n    }\n\n    .panel h2 {\n        font-size: 1.1rem;\n        margin-bottom: 0.75rem;\n    }\n\n    .panel p,\n    .account-info-list li {\n        font-size: 0.9rem;\n    }\n\n    .auth-buttons {\n        margin: 1rem 0;\n        gap: 0.5rem;\n    }\n\n    .auth-btn {\n        max-width: 100%;\n        padding: 0.75rem 1.25rem;\n        min-height: 44px;\n        font-size: 0.95rem;\n    }\n\n    .welcome-section {\n        padding: 1.5rem 0.75rem;\n        border-radius: 10px;\n    }\n\n    .welcome-section h1 {\n        font-size: 1.5rem;\n        margin-bottom: 1rem;\n    }\n\n    .welcome-text {\n        font-size: 0.95rem;\n        margin-bottom: 1.5rem;\n    }\n}\n\n.notification-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    overflow: visible;\n}\n\n.panel-info {\n    scrollbar-width: thin;\n    scrollbar-color: #3f3f46 #18181b;\n}\n\n\n.no-notifications {\n    text-align: center;\n    color: var(--text-muted);\n    padding: 2rem 1rem;\n    font-style: italic;\n}\n\n.notification-item {\n    position: relative;\n    border-radius: var(--radius-sm);\n    padding: 1rem 1.25rem;\n    margin-bottom: 0;\n    background: var(--bg-card);\n    border: 2px solid;\n    color: var(--text-primary);\n    transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s, border-color 0.2s;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n    overflow: visible;\n    max-width: 100%;\n    box-sizing: border-box;\n    scrollbar-width: none !important;\n    -ms-overflow-style: none !important;\n}\n\n.notification-item::-webkit-scrollbar {\n    display: none !important;\n}\n\n.notification-item:hover {\n    transform: translateX(4px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.notification-content {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    overflow: visible;\n    max-width: 100%;\n    scrollbar-width: none !important;\n    -ms-overflow-style: none !important;\n}\n\n.notification-content::-webkit-scrollbar {\n    display: none !important;\n}\n\n.notification-text {\n    margin: 0;\n    color: var(--text-primary);\n    line-height: 1.5;\n    word-wrap: break-word;\n    white-space: pre-wrap;\n    overflow-wrap: break-word;\n    word-break: break-word;\n    overflow: visible;\n    max-width: 100%;\n}\n\n.notification-text::-webkit-scrollbar {\n    display: none !important;\n}\n\n.notification-link-btn {\n    align-self: flex-start;\n    background: var(--accent);\n    border: 1px solid var(--accent);\n    color: white;\n    padding: 0.5rem 1rem;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    font-family: var(--font);\n    transition: background 0.2s, border-color 0.2s, transform 0.2s;\n    margin-top: 0.25rem;\n}\n\n.notification-link-btn:hover {\n    background: var(--accent-hover);\n    border-color: var(--accent-hover);\n    transform: translateY(-1px);\n}\n\n.notification-link-btn:active {\n    transform: translateY(0);\n}\n\n.notification-download-btn {\n    align-self: flex-start;\n    background: transparent;\n    border: 1px solid var(--accent);\n    color: var(--accent-light);\n    padding: 0.5rem 1rem;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    font-family: var(--font);\n    transition: background 0.2s, border-color 0.2s, transform 0.2s;\n    margin-top: 0.25rem;\n}\n\n.notification-download-btn:hover {\n    background: var(--accent-glow);\n    border-color: var(--accent);\n    color: var(--text-primary);\n    transform: translateY(-1px);\n}\n\n.notification-download-btn:active {\n    transform: translateY(0);\n}\n\n.call-request-form {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    margin-top: 0.75rem;\n    width: 100%;\n}\n\n.call-request-label {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    font-size: 0.9rem;\n    color: var(--text-secondary);\n}\n\n.call-request-input,\n.call-request-textarea {\n    width: 100%;\n    padding: 0.6rem 0.75rem;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--input-border);\n    background: var(--input-bg);\n    color: var(--text-primary);\n    font-family: var(--font);\n    font-size: 0.95rem;\n    box-sizing: border-box;\n}\n\n.call-request-textarea {\n    resize: vertical;\n    min-height: 4rem;\n}\n\n.call-request-input:focus,\n.call-request-textarea:focus {\n    outline: none;\n    border-color: var(--accent);\n    box-shadow: 0 0 0 2px var(--accent-glow);\n}\n\n.call-request-error {\n    color: var(--error);\n    font-size: 0.85rem;\n}\n\n.notification-actions {\n    display: flex;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n    flex-wrap: wrap;\n}\n\n.notification-confirm-btn,\n.notification-decline-btn {\n    min-width: 120px;\n    padding: 0.45rem 0.9rem;\n    border-radius: var(--radius-sm);\n    font-size: 0.9rem;\n    font-weight: 500;\n    font-family: var(--font);\n    cursor: pointer;\n    border-width: 1px;\n    border-style: solid;\n    transition: background 0.2s, border-color 0.2s, color 0.2s, transform 0.2s;\n}\n\n.notification-confirm-btn {\n    background: #16a34a;\n    border-color: #16a34a;\n    color: #f9fafb;\n}\n\n.notification-confirm-btn:hover {\n    background: #22c55e;\n    border-color: #22c55e;\n    transform: translateY(-1px);\n}\n\n.notification-confirm-btn:active {\n    transform: translateY(0);\n}\n\n.notification-decline-btn {\n    background: transparent;\n    border-color: #b96f80;\n    color: #fce7f3;\n}\n\n.notification-decline-btn:hover {\n    background: rgba(185, 111, 128, 0.15);\n    border-color: #b96f80;\n    color: #fdf2f8;\n    transform: translateY(-1px);\n}\n\n.notification-decline-btn:active {\n    transform: translateY(0);\n}\n\n.notification-decline-btn.secondary {\n    background: var(--bg-secondary);\n    border-color: var(--border-color);\n    color: var(--text-secondary);\n}\n\n.notification-decline-btn.secondary:hover {\n    background: var(--input-bg);\n    border-color: var(--accent);\n    color: var(--text-primary);\n}\n\n.decline-modal-body {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.decline-modal-text {\n    margin: 0;\n    color: var(--text-secondary);\n    font-size: 0.9rem;\n}\n\n.decline-modal-textarea {\n    width: 100%;\n    min-height: 100px;\n    resize: vertical;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border-color);\n    padding: 0.5rem 0.75rem;\n    background: var(--input-bg);\n    color: var(--text-primary);\n    font-family: var(--font);\n    font-size: 0.9rem;\n}\n\n.decline-modal-textarea:focus {\n    outline: none;\n    border-color: var(--accent);\n    box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.4);\n}\n\n.decline-modal-error {\n    color: var(--error);\n    font-size: 0.85rem;\n}\n\n.decline-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n}\n\n.notification-close {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n    background: var(--bg-secondary);\n    border: 1px solid var(--border-color);\n    color: var(--text-primary);\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    cursor: pointer;\n    font-size: 1.2rem;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s, transform 0.2s, border-color 0.2s;\n    padding: 0;\n    flex-shrink: 0;\n}\n\n.notification-close:hover {\n    background: var(--input-bg);\n    border-color: var(--accent);\n    transform: scale(1.1);\n}\n\n.notification-close:active {\n    transform: scale(0.95);\n}\n\n/* Старые классы для обратной совместимости (если используются где-то еще) */\n.notification {\n    background-color: black;\n    border-radius: 12px;\n    padding: 4px 12px 4px 12px;\n    margin-bottom: 12px;\n    color: white;\n}\n\n.notification p {\n    color: white;\n}\n\n.error {\n    background-color: #bc4747;\n}\n\n.warning {\n    background-color: #cfa332;\n}\n\n.success {\n    background-color: #47bc70;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
